import { configureStore } from "@reduxjs/toolkit";
import productSlice from "./slices/product/productSlice";
import commonSlice from "./slices/commonSlice";
import profileSlice from "./slices/profile/profileSlice";
import insuranceSlice from "./slices/insurance/insuranceSlice";
import buyNowSlice from "./slices/proposal/proposalSlice";
import ordersSlice from "./slices/orders/ordersSlice";
import portfolioSlice from "./slices/portfolio/portfolioSlice";
import renewalSlice from "./slices/renewal/renewalSlice";

const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  reducer: {
    product: productSlice,
    common: commonSlice,
    profile: profileSlice,
    insurance: insuranceSlice,
    buyNow: buyNowSlice,
    orders: ordersSlice,
    portfolio: portfolioSlice,
    renewal: renewalSlice,
  },
});

export default store;
